import {
  BOOK_CONSULT_CALENDLY_URL,
  BOOK_CONSULT_CONSENT_URL,
} from "../constants/externalUrls";

/**
 * Resolves the Book a Consult redirect URL.
 *
 * Current: always consent form.
 * Future: if user has Mailchimp consent-completed tag → Calendly URL; else consent form.
 *
 * @param {{ user?: object }} [_options] Reserved for future Mailchimp / user context.
 * @returns {Promise<string>}
 */
export const getBookConsultRedirectUrl = async (_options = {}) => {
  // Future: check Mailchimp tag via API; if present return BOOK_CONSULT_CALENDLY_URL.
  void BOOK_CONSULT_CALENDLY_URL;
  void _options;
  return BOOK_CONSULT_CONSENT_URL;
};

/** Redirect to Book a Consult (consent form for now). */
export const redirectToBookConsult = async (options = {}) => {
  const url = await getBookConsultRedirectUrl(options);
  window.location.href = url;
};
